import Image from 'next/image'
import React from 'react'

import { cn } from '@/utilities/ui'

const TOP_DORM_IMAGE = '/media/landing/sw-top-dorm-partner.png'
const SILVER_OPERATOR_IMAGE = '/media/landing/global-student-living-silver-certified.png'

type TrustBadgesProps = {
  className?: string
}

export const TrustBadges: React.FC<TrustBadgesProps> = ({ className }) => {
  return (
    <ul
      aria-label="Awards and certifications"
      className={cn('flex flex-wrap items-center gap-4', className)}
    >
      <li className="shrink-0">
        <Image
          alt="SW Top Dorm Partner"
          className="h-[4.125rem] w-auto max-w-none md:h-[5.625rem]"
          height={90}
          src={TOP_DORM_IMAGE}
          style={{ width: 'auto' }}
          width={90}
        />
      </li>
      <li className="shrink-0">
        <Image
          alt="Global Student Living Silver Certified Property"
          className="h-[4.74375rem] w-auto max-w-none md:h-[6.46875rem]"
          height={104}
          src={SILVER_OPERATOR_IMAGE}
          style={{ width: 'auto' }}
          width={236}
        />
      </li>
    </ul>
  )
}
